export default "__VITE_ASSET__CihM7mDT__"